import { render, staticRenderFns } from "./PrePurchase_model.vue?vue&type=template&id=97bf6432&scoped=true"
import script from "./PrePurchase_model.vue?vue&type=script&lang=js"
export * from "./PrePurchase_model.vue?vue&type=script&lang=js"
import style0 from "./PrePurchase_model.vue?vue&type=style&index=0&id=97bf6432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bf6432",
  null
  
)

export default component.exports